<template>
    <FormModal :model="model" :init="init" modal-id="user">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <b-form-group
                label-cols-sm="2"
                label="権限"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-form-radio-group v-model="model.level" size="sm">
                    <b-form-radio value="000">なし</b-form-radio>
                    <b-form-radio value="100">一般</b-form-radio>
                    <b-form-radio value="200">編集者</b-form-radio>
                    <b-form-radio value="300">管理者</b-form-radio>
                </b-form-radio-group>
                <input-error :errors="error.level" />
            </b-form-group>
            <b-form-group
                label-cols-sm="2"
                label="状態"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-form-radio-group v-model="model.status" size="sm">
                    <b-form-radio value="pending">仮登録</b-form-radio>
                    <b-form-radio value="activated">登録済</b-form-radio>
                    <b-form-radio value="suspended">停止中</b-form-radio>
                </b-form-radio-group>
                <input-error :errors="error.status" />
            </b-form-group>
            <b-form-group
                label-cols-sm="2"
                label="メール"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-form-input
                    v-model="model.email"
                    size="sm"
                    placeholder="email@example.com"
                    ></b-form-input>
                <input-error :errors="error.email" />
            </b-form-group>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        FormModal,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped></style>


